import { HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable, catchError, delay, map, merge, of, retry, startWith } from 'rxjs';

@Pipe({
  name: 'imageLoading',
})
export class ImageLoadingPipe implements PipeTransform {
  constructor(private readonly http: HttpClient, private readonly sanitizer: DomSanitizer) {}

  transform(url?: string): Observable<SafeUrl> {
    // return the url if it is a base64 image
    if (url?.startsWith('data:image')) {
      return of(this.sanitizer.bypassSecurityTrustUrl(url));
    }

    if (!url || url.length === 0) {
      return merge(
        of(this.sanitizer.bypassSecurityTrustUrl('assets/loading.webp')),
        of(this.sanitizer.bypassSecurityTrustUrl('assets/placeholder-image.png')).pipe(delay(1000)),
      );
    }

    return this.http.get<{ presignedUrl: string }>(url).pipe(
      startWith({ presignedUrl: 'assets/loading.webp' }),
      retry({ count: 15, delay: 3000 }),
      map((res) => this.sanitizer.bypassSecurityTrustUrl(res.presignedUrl)),
      catchError(() => {
        return of(this.sanitizer.bypassSecurityTrustUrl('assets/placeholder-image.png'));
      }),
    );
  }
}
